import { Button, Card, Input, Table } from "@chakra-ui/react";
import { CiFilter, CiMedicalCross } from "react-icons/ci";
import { FiDownload, FiTag } from "react-icons/fi";
import { GoSortAsc } from "react-icons/go";
import { useNavigate } from "react-router-dom";

const inventoryItems = [
  {
    sku: "123456",
    productName: "Arthemeter",
    category: "Malaria",
    sellingPrice: 5000,
    totalInventory: "150 pack",
    stockLevel: "Out of Stock", // Out of Stock | In Stock | Low Stock
    unitSold: 100,
    status: "inactive", // active | inactive
  },
  {
    sku: "123457",
    productName: "Blood Pressure Monitor",
    category: "Hypertension",
    sellingPrice: 12000,
    totalInventory: "50 pack",
    stockLevel: "In Stock",
    unitSold: 200,
    status: "active",
  },
  {
    sku: "123458",
    productName: "Cough Syrup",
    category: "Bronchitis",
    sellingPrice: 2500,
    totalInventory: "100 pack",
    stockLevel: "In Stock",
    unitSold: 300,
    status: "active",
  },
  {
    sku: "123459",
    productName: "Pain Reliever",
    category: "Pain relief",
    sellingPrice: 1500,
    totalInventory: "200 pack",
    stockLevel: "Low Stock",
    unitSold: 500,
    status: "active",
  },
  {
    sku: "123460",
    productName: "Antibiotics",
    category: "Bacterial Infections",
    sellingPrice: 8000,
    totalInventory: "70 pack",
    stockLevel: "Out of Stock",
    unitSold: 80,
    status: "inactive",
  },
  {
    sku: "123461",
    productName: "Vitamin C",
    category: "Immune Support",
    sellingPrice: 2000,
    totalInventory: "150 pack",
    stockLevel: "In Stock",
    unitSold: 400,
    status: "active",
  },
  {
    sku: "123462",
    productName: "Vitamin C",
    category: "Immune Support",
    sellingPrice: 2000,
    totalInventory: "150 pack",
    stockLevel: "In Stock",
    unitSold: 400,
    status: "active",
  },
  {
    sku: "123463",
    productName: "Vitamin C",
    category: "Immune Support",
    sellingPrice: 2000,
    totalInventory: "150 pack",
    stockLevel: "In Stock",
    unitSold: 400,
    status: "active",
  },
];

export const Inventory = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="flex items-center justify-between">
        <h1 className="text-2xl! font-semibold">Inventory</h1>

        <Button variant="outline" size={"sm"}>
          <FiDownload />
          Import
        </Button>
      </div>

      <div className="mt-8! grid grid-cols-1 md:grid-cols-4 gap-4!">
        <div className="bg-white p-3! border! border-gray-200! col-span-1 rounded-lg md:col-span-2">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-lg! text-black! mb-2!">
                Total Inventory Products
              </p>
              <p className="text-2xl! font-semibold! text-black!">
                30,000,000.00
              </p>
            </div>

            <div className="bg-[#E6ECF7] flex items-center justify-center h-8 w-8 rounded-lg">
              <FiTag color="#0142B1" />
            </div>
          </div>

          <div className="mt-7! grid grid-cols-1 md:grid-cols-3 gap-4!">
            <div className="p-3! rounded-xl bg-[#E6ECF7]">
              <p className="text-sm! text-black! mb-1!">Categories</p>

              <p className="text-xl! font-semibold! text-black!">30,000</p>
            </div>
            <div className="p-3! rounded-xl bg-[#E6ECF7]">
              <p className="text-sm! text-black! mb-1!">Categories</p>

              <p className="text-xl! font-semibold! text-black!">30,000</p>
            </div>
            <div className="p-3! rounded-xl bg-[#E6ECF7]">
              <p className="text-sm! text-black! mb-1!">Categories</p>

              <p className="text-xl! font-semibold! text-black!">30,000</p>
            </div>
          </div>
        </div>
        <Card.Root>
          <Card.Body>
            <div className="flex items-center justify-between ">
              <p className="text-black font-medium! text-sm!">Pharmacies</p>

              <div className="w-6 h-6 flex items-center justify-center bg-[#E6ECF7] rounded-md">
                <CiMedicalCross color="#0142B1" />
              </div>
            </div>
          </Card.Body>
          <Card.Footer>
            <h5 className="font-bold! text-2xl! text-black!">900</h5>
          </Card.Footer>
        </Card.Root>
        <Card.Root>
          <Card.Body>
            <div className="flex items-center justify-between ">
              <p className="text-black font-medium! text-sm!">Total Revenue</p>

              <div className="w-6 h-6 flex items-center justify-center bg-[#E6ECF7] rounded-md">
                <CiMedicalCross color="#0142B1" />
              </div>
            </div>
          </Card.Body>
          <Card.Footer>
            <h5 className="font-bold! text-2xl! text-black!">900</h5>
          </Card.Footer>
        </Card.Root>
      </div>

      <div className="flex items-center justify-between mt-12!">
        <p className="text-xl! font-medium! text-black!">All Inventory</p>

        <div className="flex items-center gap-3">
          <Input size={"sm"} placeholder={"Search"} />

          <Button variant={"outline"} size={"sm"}>
            <CiFilter />
            Filter
          </Button>

          <Button variant={"outline"} size={"sm"}>
            <GoSortAsc />
            Sort
          </Button>
        </div>
      </div>

      <div className="mt-6! bg-white rounded-lg border! border-gray-200!">
        <Table.Root size="md" striped>
          <Table.Header>
            <Table.Row className="bg-gray-50!">
              <Table.ColumnHeader>
                <input type="checkbox" className="w-4 h-4" />
              </Table.ColumnHeader>
              <Table.ColumnHeader>SKUs</Table.ColumnHeader>
              <Table.ColumnHeader>Product Name</Table.ColumnHeader>
              <Table.ColumnHeader>Category</Table.ColumnHeader>
              <Table.ColumnHeader>Selling Price</Table.ColumnHeader>
              <Table.ColumnHeader>Total Inventory</Table.ColumnHeader>
              <Table.ColumnHeader>Stock Level</Table.ColumnHeader>
              <Table.ColumnHeader>Unit Sold</Table.ColumnHeader>
              <Table.ColumnHeader>Status</Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {inventoryItems.map((item) => (
              <Table.Row
                onClick={() => navigate(`/inventory/${item.sku}`)}
                key={item.sku}
                className="border-b! border-gray-200!">
                <Table.Cell>
                  <input type="checkbox" className="w-4 h-4" />
                </Table.Cell>
                <Table.Cell className="font-medium!">{item.sku}</Table.Cell>
                <Table.Cell className="font-medium!">
                  {item.productName}
                </Table.Cell>
                <Table.Cell>{item.category}</Table.Cell>
                <Table.Cell className="font-medium!">
                  {item.sellingPrice}
                </Table.Cell>
                <Table.Cell>{item.totalInventory}</Table.Cell>
                <Table.Cell>
                  <span
                    className={`px-3! py-1! rounded-md text-xs! font-medium ${
                      item.stockLevel === "Out of Stock"
                        ? "bg-red-50 text-red-600 border border-red-200"
                        : item.stockLevel === "In Stock"
                        ? "bg-green-50 text-green-600 border border-green-200"
                        : "bg-yellow-50 text-yellow-600 border border-yellow-200"
                    }`}>
                    {item.stockLevel}
                  </span>
                </Table.Cell>
                <Table.Cell className="font-medium!">
                  {item.unitSold}
                </Table.Cell>
                <Table.Cell>
                  <span
                    className={`px-3! py-1! rounded-md text-xs! font-medium capitalize ${
                      item.status === "active"
                        ? "bg-blue-600 text-white"
                        : "bg-gray-100! text-gray-600! border! border-gray-300!"
                    }`}>
                    {item.status}
                  </span>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      </div>
    </div>
  );
};
